import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../../constants";
export default {
    SET_BACK_URL_HASH: createActionType(FULL_NAMESPACE, "SET_BACK_URL_HASH")
};
